import { Box, CardMedia, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import adnexioFooterLogo from '../assets/adnexio-invoke-footer-logo.svg'

const JobBoardFooter = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box
      sx={{
        backgroundColor: 'black',
        padding: isMobile ? '32px 16px' : '51px 61px',
        width: '100%',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        gap: isMobile ? '64px' : null,
      }}
    >
      <Box>
        <CardMedia
          component="img"
          src={adnexioFooterLogo}
          sx={{
            width: '100%',
            height: '30px',
            objectFit: 'contain',
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '16px',
        }}
      >
        <Typography variant="h4" sx={{ color: 'alternate.main' }}>
          INFO
        </Typography>
        <a style={{ textDecoration: 'none' }} href={`https://adnexio.jobs/terms-conditions`}>
          <Typography variant="h4" sx={{ color: 'white.main', cursor: 'pointer' }}>
            Terms & Conditions
          </Typography>
        </a>
        <a style={{ textDecoration: 'none' }} href={`https://adnexio.jobs/privacy-policy`}>
          <Typography variant="h4" sx={{ color: 'white.main', cursor: 'pointer' }}>
            Privacy Policy
          </Typography>
        </a>
      </Box>
    </Box>
  )
}

export default JobBoardFooter
